import { useEffect } from 'react';
import { IPermissionModel, RBAC_MODEL, Role } from '../constant';
import { decryptData } from '@helper/encryptDecrypt';
import Cookies from 'universal-cookie';
import { useRolesPermission } from '@store/rolesPermissionStore';

const getRole = async (role: string): Promise<string> => {
	return await decryptData(role);
};

export const usePermission = (): IPermissionModel[] => {
	const { permissions, setPermissions, role: persistedRole, setRole } = useRolesPermission();

	const cookieRole = new Cookies().get('role') as string | undefined;

	useEffect(() => {
		let isMounted = true;

		const fetchRole = async (): Promise<void> => {
			try {
				if (!cookieRole) {
					if (isMounted) {
						if (permissions.length > 0) {
							setPermissions([]);
						}

						if (persistedRole !== null) {
							setRole(null);
						}
					}
					return;
				}
				const decryptedRole = await getRole(cookieRole);
				if (!isMounted) return;
				if (permissions.length > 0 && persistedRole === decryptedRole) {
					return;
				}
				const newPermissions = RBAC_MODEL[decryptedRole as Role] ?? [];

				setPermissions(newPermissions);
				setRole(decryptedRole);
			} catch (error) {
				console.error('Error fetching role:', error);
			}
		};

		void fetchRole();

		return (): void => {
			isMounted = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cookieRole]);

	return permissions;
};
